import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.appColors.primaryHeaderColor,
    alignItems: 'center',
  },

  containerGrid: {
    backgroundColor: theme.appColors.white,
    padding: '6vh 5vw',
    borderRadius: '8px',
    margin: theme.spacing(5, 0),
    [theme.breakpoints.only('xs')]: {
      padding: '6vh 4vw',
      margin: 0,
      borderRadius: '0px',
    },
    [theme.breakpoints.only('sm')]: {
      padding: '6vh 4vw',
    },
  },

  link: {
    fontSize: '14px',
    fontWeight: 400,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.63',
    letterSpacing: 'normal',
    textAlign: 'left',
    textDecoration: 'underline',
    color: theme.appColors.primaryColor,
    fontFamily: 'Inter',
    '&:hover': {
      filter: 'brightness(80%)',
    },
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      fontWeight: 700,
    },
  },

  titulo: {
    fontFamily: theme.typography.bancoDoBrasilTitulos.fontFamily,
    color: theme.appColors.purpleText,
    fontSize: 24,
    textAlign: 'left',
    fontWeight: 500,
  },
  subTitulo: {
    color: theme.appColors.darkGray,
    fontFamily: theme.typography.bancoDoBrasilTitulos.fontFamily,
    fontSize: 14,
    letterSpacing: -0.46,
    opacity: 0.699999988079071,
    textAlign: 'left',
    lineHeight: '26px',
  },

  button: {
    color: '#FFFFFF',
    fontFamily: 'BancoDoBrasilTitulos',
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0.66px',
    textAlign: 'center',
    marginTop: theme.spacing(1),
    width: 180,
    height: '48px',
    marginBottom: 24,
    textTransform: 'uppercase',
    [theme.breakpoints.down('xs')]: {
      width: '90vw',
    },
  },
  input: {
    margin: '36px 0 16px',
    '& .MuiInputBase-root': {
      height: '48px',
    },
  },
}));
